/**
 * Decode an encoded polyline string into an array of lat/lng coordinates.
 * Valhalla uses precision 6 (default), while Google Maps uses precision 5.
 */
export function decodePolyline(encoded: string, precision: number = 6): { lat: number; lng: number }[] {
    const factor = Math.pow(10, precision);
    const points: { lat: number; lng: number }[] = [];
    let index = 0;
    let lat = 0;
    let lng = 0;

    while (index < encoded.length) {
        let shift = 0;
        let result = 0;
        let byte: number;

        do {
            byte = encoded.charCodeAt(index++) - 63;
            result |= (byte & 0x1f) << shift;
            shift += 5;
        } while (byte >= 0x20);

        lat += (result & 1) ? ~(result >> 1) : (result >> 1);

        shift = 0;
        result = 0;

        do {
            byte = encoded.charCodeAt(index++) - 63;
            result |= (byte & 0x1f) << shift;
            shift += 5;
        } while (byte >= 0x20);

        lng += (result & 1) ? ~(result >> 1) : (result >> 1);

        points.push({ lat: lat / factor, lng: lng / factor });
    }

    return points;
}
